(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hp-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const dialog = document.getElementById('hp-newsletter-popup');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const key = 'hp-newsletter-seen-v1';
      const preview = new URLSearchParams(location.search).get('newsletter_preview') === '1';
      let shown = false;
      let timer;
      const recentlySeen = () => {
        try { return Date.now() - Number(localStorage.getItem(key) || 0) < 604800000; }
        catch { return false; }
      };
      const show = () => {
        if (shown || document.hidden || (!preview && recentlySeen())) return;
        if (document.querySelector('dialog[open], cart-drawer.active, details[open] menu-drawer')) return;
        const consent = document.getElementById('shopify-pc__banner');
        if (consent && consent.getClientRects().length) return;
        if (document.activeElement?.matches('input, textarea, select')) return;
        const frame = dialog.querySelector('iframe');
        if (!frame) return;
        frame.src = frame.dataset.src;
        dialog.showModal();
        shown = true;
        clearInterval(timer);
        document.removeEventListener('visibilitychange', show);
        if (!preview) {
          try { localStorage.setItem(key, String(Date.now())); } catch {}
        }
      };
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      if (!preview && (window.Shopify?.designMode || recentlySeen())) return;
      setTimeout(() => {
        document.addEventListener('visibilitychange', show);
        timer = setInterval(show, 1000);
        show();
      }, preview ? 0 : 6000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
